'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@/app/components/button';
import { IconPlayArrow } from '@/app/components/icons/audio-video/icon-play-arrow';
import { Image } from '@/app/components/media/image';
import type { ImageProps } from '@/app/components/media/image/types';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA, type DataGAProps } from '@/app/utils/createDataGA';
import { safeCall } from '@/app/utils/safeCall';
interface ImageContentProps {
  className?: string;
  buttonClassName?: string;
  image: Omit<ImageProps, 'aspectRatio'>;
  youtubeId?: string;
  tracking?: Omit<DataGAProps, 'click'>;
  openYoutubeModal?: () => void;
}
export const ImageContent = t0 => {
  const $ = _c(27);
  const {
    image,
    className,
    buttonClassName,
    youtubeId,
    tracking,
    openYoutubeModal
  } = t0;
  if (!image) {
    return null;
  }
  let t1;
  if ($[0] !== openYoutubeModal || $[1] !== youtubeId) {
    t1 = () => {
      if (!youtubeId) {
        return;
      }
      safeCall(openYoutubeModal);
    };
    $[0] = openYoutubeModal;
    $[1] = youtubeId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleOpenYoutubeModal = t1;
  const t2 = !!youtubeId;
  let t3;
  if ($[3] !== className || $[4] !== t2) {
    t3 = cn("aspect-3-2 relative w-full transform-gpu overflow-hidden rounded-md lg:max-w-115 xl:max-w-144", {
      "group cursor-pointer": t2
    }, className);
    $[3] = className;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = createDataAttributes({
      test: "image-content"
    });
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = !!youtubeId;
  const t6 = !!image.priority;
  const t7 = !!youtubeId ? "zoom" : undefined;
  let t8;
  if ($[7] !== image.alt || $[8] !== image.height || $[9] !== image.src || $[10] !== image.width || $[11] !== t5 || $[12] !== t6 || $[13] !== t7) {
    t8 = <Image className="size-full" isGroupHover={t5} priority={t6} src={image.src} alt={image.alt} height={image.height} width={image.width} layout="fill" aspectRatio="aspect-3-2" sizes="(min-width: 1024px) 600px, 100vw" hoverEffect={t7} />;
    $[7] = image.alt;
    $[8] = image.height;
    $[9] = image.src;
    $[10] = image.width;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== buttonClassName || $[16] !== handleOpenYoutubeModal || $[17] !== tracking?.eventName || $[18] !== tracking?.group || $[19] !== youtubeId) {
    t9 = !!youtubeId && <Button className={cn("center-x center-y absolute group-hover:bg-gray-600 group-hover:text-white", buttonClassName)} color="white" iconBefore={<IconPlayArrow />} onClick={handleOpenYoutubeModal} {...createDataAttributes({
      test: "youtube-button"
    })} {...createDataGA({
      click: true,
      eventName: tracking?.eventName,
      group: tracking?.group,
      url: "youtube-button",
      text: "youtube-button"
    })} />;
    $[15] = buttonClassName;
    $[16] = handleOpenYoutubeModal;
    $[17] = tracking?.eventName;
    $[18] = tracking?.group;
    $[19] = youtubeId;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== handleOpenYoutubeModal || $[22] !== t3 || $[23] !== t4 || $[24] !== t8 || $[25] !== t9) {
    t10 = <><div className={t3} onClick={handleOpenYoutubeModal} {...t4}>{t8}{t9}</div></>;
    $[21] = handleOpenYoutubeModal;
    $[22] = t3;
    $[23] = t4;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};